import { createStyles } from "@mantine/core";

const useStyles = createStyles((theme) => ({
  createBtn: {
    padding: "12px 20px",
    borderRadius: "8px",
    border: "1px solid #FFAF4A",
    backgroundColor: "#FFAF4A",
    height: 44,
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
    fontSize: 16,
    fontWeight: 600,
    fontFamily: "Inter",
    color: "#262626",
    ":hover": {
      backgroundColor: "#FFAF4A",
      opacity: 0.8,
    },
  },
  cancelBtn: {
    padding: "12px 20px",
    borderRadius: "8px",
    border: "1px solid #D0D5DD",
    backgroundColor: "#F9FAFB",
    height: 44,
    height: 44,
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
    fontSize: 16,
    fontWeight: 600,
    fontFamily: "Inter",
    color: "#262626",
    ":hover": {
      backgroundColor: "#F9FAFB",
      opacity: 0.8,
    },
  },
  formBox: {
    width: "100%",
    marginBlock: "8px 32px",
    padding: "24px 15px",
    borderRadius: 12,
    border: "1px solid #E5E5E5",
    backgroundColor: "#FFF",
  },
  inputField: {
    "& .mantine-InputWrapper-label": {
      fontSize: 14,
      fontWeight: 500,
      fontFamily: "Inter",
      color: "#404040",
      marginBottom: 6,
    },
    "& .mantine-Input-wrapper": {
      padding: "08px 12px",
      height: 38,
      borderRadius: 8,
      border: "1px solid #D0D5DD",
      background: "transparent",
      boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
      "& input, & .mantine-PasswordInput-input": {
        height: "100%",
        border: "none",
        padding: "0px",
        background: "transparent",
        minHeight: "unset",
        fontSize: 16,
        fontWeight: 400,
        fontFamily: "Inter",
        color: "#171717",

        "&:-webkit-autofill": {
          boxShadow: "0 0 0px 1000px transparent inset !important",
          WebkitTextFillColor: "#171717",
          transition: "background-color 5000s ease-in-out 0s",
        },

        "&::placeholder": {
          color: "#737373",
        },
      },
    },
    "& .mantine-Select-wrapper": {
      padding: 0,
      "& .mantine-Select-input": {
        paddingLeft: 12,
        paddingRight: 36,
      },
    },
  },
  multiSelect: {
    "& .mantine-MultiSelect-rightSection": {
      width: "fit-content",
      right: 13
    },
    "& .mantine-MultiSelect-input": {
      padding: "0px 12px",
      border: "none",
      "& .mantine-MultiSelect-values": {
        overflowY: "auto",
        minHeight: 38,
      },
    },
    "& .mantine-Input-wrapper": {
      height: "auto",
      padding: 0,
    },
  },

  //   ************* Date Range Picker *************
  buttonStyle: {
    margin: "6px 0 0 0",
    width: "100%",
    height: 40,
    padding: "0px 16px",
    backgroundColor: "#ffffff",
    color: "#262626",
    border: "1px solid #D4D4D4",
    borderRadius: "8px",
    fontFamily: "Inter",
    fontSize: "14px",
    fontWeight: 600,
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05), 0 0 0 4px #F2F4F7",
    "&:hover": {
      backgroundColor: "#ffffff",
    },
    "& .mantine-Button-inner": {
      justifyContent: "flex-start",
    },
  },
  datePickerParent: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    "@media (max-width:834px)": {
      display: "block",
    },
  },
  popOverCard: {
    "@media (max-width:992px)": {
      left: "250px !important",
    },
    "@media (max-width:600px)": {
      left: "18px !important",
    },
    "@media (max-width:360px)": {
      left: "0px !important",
    },
  },
  buttonsParent: {
    borderRight: "1px solid #F5F5F5",
    display: "flex",
    flexDirection: "column",
    padding: "0 10px 0 0",
    "@media (max-width:834px)": {
      borderRight: "none",
    },
  },
  datePickerParentDiv: {
    // padding: "10px 0 10px 0",
  },
  datePicker: {
    padding: "0 10px 0 10px",
  },

  dateButtons: {
    width: "auto",
    marginTop: "12px",
    transition: "0.5s",
    backgroundColor: "transparent",
    textTransform: "capitalize",
    "&:hover": {
      backgroundColor: "#F5F5F5",
      color: "#262626",
    },
    color: "#000000",
    "@media (max-width:834px)": {
      backgroundColor: "#262626",
      color: "#F5F5F5",
    },
  },
  activeButton: {
    backgroundColor: "#000",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#000",
      color: "#fff",
    },
  },
  bottomButtonsParent: {
    borderTop: "1px solid #F5F5F5",
    paddingTop: "10px",
  },
  bottomButtons: {
    marginLeft: "15px",
  },
  cancelButton: {
    backgroundColor: "#F5F5F5",
    color: "#262626",
    "&:hover": {
      backgroundColor: "#F5F5F5",
    },
  },
  applyButton: {
    backgroundColor: "#262626",
    width: "55%",
    "&:hover": {
      backgroundColor: "#262626",
    },
  },
  iconCalendar: {
    margin: "0 8px 0 0",
  },
}));

export default useStyles;
